;(function (angular) {
  'use strict'

  class CategoryService {
    constructor (
      // Angular
      // Libs
      $uibModal,
      // Managers
      CategoryManager,
      // Services
      SnackService, SessionService
      // Const
      // Resolved
    ) {
      this.$uibModal = $uibModal
      this.categoryManager = CategoryManager
      this.snackService = SnackService
      this.sessionService = SessionService
    }

    /**
       * Get categories
       * @return {Promise<>}
       */
    getCategories () {
      return this.categoryManager.get(
        this.categoryManager
          .query()
          .select(this.sessionService.getCompany(), 'company')
      ).then((data) => {
        return data.data
      })
    }

    /**
       * Edit category
       * @param category
       * @return {Promise<>}
       */
    editCategory (category) {
      return this.$uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/preferences/categories/create-category.html',
        controller: 'CreateCategoryController',
        controllerAs: 'createcat',
        resolve: {
          category: () => {
            if (category) {
              return angular.copy(category)
            }
            return this.categoryManager.create({ label: '' })
          }
        }
      }).result.then((res) => {
        if (res) {
          res.save().then(() => {
            this.snackService.snack({
              text: 'Catégorie enregistrée !',
              delay: 5000
            })
          })
        }
      })
    }

    /**
       * Delete category
       * @param category
       * @return {Promise<>}
       */
    deleteCategory (category) {
      return this.$uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/preferences/categories/delete-category.html',
        controller: 'DeleteCategoryController',
        controllerAs: 'delcat'
      }).result.then((res) => {
        if (res === true) {
          category.remove().then(() => {
            this.snackService.snack({
              text: 'Catégorie supprimée !',
              delay: 5000
            })
          })
        }
      })
    }
  }

  CategoryService.$inject = [
    // Angular
    // Libs
    '$uibModal',
    // Managers
    'CategoryManager',
    // Services
    'SnackService', 'SessionService'
    // Const
    // Resolved
  ]
  angular
    .module('kilo.common.services')
    .service('CategoryService', CategoryService)
})(window.angular)
